'use client'

import { SpeedInsights } from '@vercel/speed-insights/next'
import { useEffect, useState } from 'react'

// Wraps SpeedInsights in a client component so the beforeSend filter (a
// function) can be passed without crossing the server/client boundary —
// Next.js can't serialize functions through a Server Component.
//
// sampleRate: 10% sampling cuts data points from ~614K/mo to ~61K/mo (~$36/mo
//   savings) while still being statistically meaningful for Core Web Vitals.
// beforeSend: drops /admin URLs defensively. The (app) layout doesn't wrap
//   (payload)/admin so this should be a no-op, but guards against future
//   cross-layout SpeedInsights mounts. See EA-682.
export default function SpeedInsightsConfigured() {
  // The /_vercel/speed-insights/script.js endpoint is only served on Vercel deployments,
  // so it 404s on localhost (notably under `next start` prod builds, which load the prod
  // script rather than the dev debug one). Gate to non-local hosts to keep the local
  // console clean; Speed Insights still runs on Vercel preview/prod.
  const [onVercelHost, setOnVercelHost] = useState(false)
  useEffect(() => {
    const host = window.location.hostname
    setOnVercelHost(host !== 'localhost' && host !== '127.0.0.1' && host !== '[::1]')
  }, [])

  if (!onVercelHost) return null

  return (
    <SpeedInsights
      sampleRate={0.1}
      beforeSend={(data) => {
        try {
          const pathname = new URL(data.url, window.location.origin).pathname
          if (pathname === '/admin' || pathname.startsWith('/admin/')) return null
          return data
        } catch {
          return data
        }
      }}
    />
  )
}
